<img
  [mat-dialog-close]
  [src]="imageSrc"
  style="max-width: 100%; max-height: 100%"
/>
